import React from "react";

import { useLoginStepsContext } from "../contexts";

export const useLoginSharedData = () => {
  const { sharedData, onSharedDataChange } = useLoginStepsContext();

  const setErrorCallback = React.useCallback(
    errorCallback => {
      onSharedDataChange(prev => ({ ...prev, errorCallback }));
    },
    [onSharedDataChange]
  );

  const setSuccessCallback = React.useCallback(
    successCallback => {
      onSharedDataChange(prev => ({ ...prev, successCallback }));
    },
    [onSharedDataChange]
  );

  const setUserDetails = React.useCallback(
    userDetails => {
      onSharedDataChange(prev => ({ ...prev, userDetails }));
    },
    [onSharedDataChange]
  );

  return {
    sharedData,
    setErrorCallback,
    setSuccessCallback,
    setUserDetails,
  };
};
